import { render, staticRenderFns } from "./reportage.vue?vue&type=template&id=a84972dc&"
import script from "./reportage.vue?vue&type=script&lang=js&"
export * from "./reportage.vue?vue&type=script&lang=js&"
import style0 from "./reportage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports